import { useState, useEffect } from 'react'

function useIsMobile () {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      setIsMobile(width < 768)
    }

    window.addEventListener('resize', handleResize)
    handleResize() // direkt beim Mount aufrufen, um sicherzugehen

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return { windowWidth, isMobile }
}

export default useIsMobile
